import PropTypes from 'prop-types';
import React from 'react';
import PropertyInfo from './property-info';
import Linkify from '../../shared/linkify';

const Slide = ({listing, index, width, isSelected, numSlides, heroOptions}) => {
  const hasHeroMessage = heroOptions.showHeroMessage && heroOptions.heroMessage;
  let queryString = '';
  let tabIndex = isSelected ? '0' : '-1';
  if (width < 1024) {
    queryString = '?width=1024';
  }   
  return (   
    <div role="group" aria-label={`slide ${index+1} of ${numSlides}`}>
      <Linkify to={listing.listingLink} tabIndex={tabIndex}>
        <div style={{backgroundImage: `url(${listing.heroImage}${queryString})`}} className={`image ${hasHeroMessage ? 'ada-overlay' : ''}`}>
          <img src="/img/listing/transparent-16-9.png" alt={`listing view ${index+1}`}/>
        </div>
      </Linkify>
      <div className="legend">
        <div className="listing-outer">
          <Linkify to={listing.listingLink} tabIndex={tabIndex}>
            <PropertyInfo listing={listing}/>
          </Linkify>
        </div>
        <a href="#agent-teaser" tabIndex={tabIndex} aria-label="scroll down to agent info">
          <span className="arrow-down scroll-link"></span>
        </a>
        <div className="listing-outer hidden-xs">
        {listing.listingLink != null &&
          <span className="listing-link">
            <Linkify to={listing.listingLink} tabIndex={tabIndex}>View Property</Linkify>
          </span>
       }
        </div>
      </div>
    </div>
  );
};

Slide.propTypes = {
  listing: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  heroSliderOptions: PropTypes.object.isRequired,
};

export default Slide;



// WEBPACK FOOTER //
// ./src/components/homepage/hero-slider/slide.js